var render, staticRenderFns
import script from "./ButtonIcon.vue?vue&type=script&lang=ts&"
export * from "./ButtonIcon.vue?vue&type=script&lang=ts&"
import style0 from "./ButtonIcon.vue?vue&type=style&index=0&id=230f06f2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports